import React, { useEffect, useState } from "react";

import {
  Paper,
  makeStyles,
  Button,
  Box,
  Table,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Backdrop,
  CircularProgress,
  TableContainer,
  Switch
} from "@material-ui/core";

import AddIcon from "@material-ui/icons/Add";
import { Pagination } from "@material-ui/lab";
import DeleteIcon from "@material-ui/icons/Delete";
import CreateSubCategory from "./CreateSubCategory";
import UpdateSubCategory from "./UpdateSubCategory";

import AlertDialog from "../../components/Alert/AlertDialog";
import { useDispatch, useSelector } from "react-redux";

import Notification from "../../components/Notification/Notification";
import EditIcon from "@material-ui/icons/Edit";
import {
  hideSubCategory,
  deleteSubCategory,
  getSubCategory,
} from "../../store/action/subCategory/subCategoryAction";
import EnhancedTableHead from "./EnhancedTableHead";
import { headCells } from "./Headcells";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
    padding: 20,
    backgroundColor: theme.palette.background.main,
  },
  container: {
    marginTop: "15px",
    maxHeight: "calc(100vh - 260px)",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  viewBtn: {
    display: "flex",
    alignItems: "center",
  },
}));

const SubCategory = () => {
  const classes = useStyle();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [Id, setId] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [page, setPage] = useState(1);
  const [openUpdate, setOpenUpdate] = useState(false);
  const { getSubCategoryItem, loading } = useSelector(
    (state) => state.subCategory
  );
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("title");
  const handleClickOpen = (id) => {
    setOpen(true);
  };

  const handleClose = (action) => {
    setOpen(false);
    if (action === "update") {
      getSubCategory(page);
    }
    setOpenUpdate(false);
  };

  const hideSubcategory = (id) => {
    dispatch(hideSubCategory(id));
  };

  const deleteCategories = (sub_category_id) => {
    setDisabled(true);
    setId(sub_category_id);
    setDeleteOpen(true);
  };
  const deleteSubCategoryClose = () => {
    setDeleteOpen(false);
  };
  const alertResponse = (id) => {
    if (disabled === true) {
      dispatch(deleteSubCategory(id));
    }
    setDisabled(false);
  };

  const handleUpdateClickOpen = (id) => {
    setOpenUpdate(true);
    setId(id);
  };

  const handleRequestSort = (
    property,
    setOrder,
    setOrderBy,
    orderBy,
    order
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  useEffect(() => {
    dispatch(getSubCategory(orderBy, order));
  }, [dispatch, orderBy, order]);

  return (
    <>
      <Paper className={`${classes.root} mb-6 mt-5`}>
        <Box
          className="mb-5"
          display="flex"
          alignItems="center"
          justifyContent="flex-end"
        >
          <div className="ml-5">
            <Button
              variant="contained"
              style={{ textTransform: "capitalize" }}
              color="primary"
              onClick={handleClickOpen}
            >
              <AddIcon className="mr-2" />
              Add Sub Category
            </Button>
          </div>
        </Box>

        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table">
            <EnhancedTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={(event, property) => {
                handleRequestSort(
                  property,
                  setOrder,
                  setOrderBy,
                  orderBy,
                  order
                );
              }}
              rowCount={getSubCategoryItem?.data?.data?.length}
              headCells={headCells[0]}
            />

            <TableBody>
              {getSubCategoryItem?.data &&
                getSubCategoryItem.data.map((row, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell scope="row">{index + 1}</TableCell>
                      <TableCell align="left">
                        <Switch
                          checked={row.is_hide}
                          onChange={() => hideSubcategory(row.id)}
                          color="primary"
                        />
                      </TableCell>
                      <TableCell align="left">{row.title}</TableCell>
                      <TableCell align="left">{row.is_active}</TableCell>
                      <TableCell align="center">
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="flex-end"
                        >
                          <IconButton
                            onClick={() => handleUpdateClickOpen(row.id)}
                            style={{ padding: 6 }}
                          >
                            <EditIcon color="primary" />
                          </IconButton>
                          <IconButton
                            onClick={() => deleteCategories(row.id)}
                            style={{ padding: 6 }}
                          >
                            <DeleteIcon color="secondary" />
                          </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                })}
              {!getSubCategoryItem?.data && (
                <TableRow>
                  <TableCell scope="row" colSpan="15">
                    <div className="" align="center">
                      Sorry, Sub Category not available!
                    </div>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      <CreateSubCategory open={open} handleClose={handleClose} />
      <UpdateSubCategory
        openUpdate={openUpdate}
        handleClose={handleClose}
        id={Id}
      />
      <AlertDialog
        id={Id}
        response={alertResponse}
        open={deleteOpen}
        close={deleteSubCategoryClose}
        title="Delete Sub Category"
        description="Are you sure you want to delete Sub Category?"
        buttonName="Delete"
      />

      {loading ? (
        <Backdrop className={classes.backdrop} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        ""
      )}
    </>
  );
};

export default SubCategory;
